(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1832],{

/***/ 8192:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inicio",
      function () {
        return __webpack_require__(48057);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39425);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3638);





var HomeLoggedIn = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    var promise = Promise.all(/* import() */[__webpack_require__.e(9072), __webpack_require__.e(729), __webpack_require__.e(6023), __webpack_require__.e(1039), __webpack_require__.e(3348), __webpack_require__.e(9362), __webpack_require__.e(20), __webpack_require__.e(960), __webpack_require__.e(3900)]).then(__webpack_require__.bind(__webpack_require__, 84998)).then(function(mod) {
        return mod.HomeLoggedIn;
    });
    return promise;
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84998)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return null;
    }
});
var HomeLoggedOut = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    var promise = Promise.all(/* import() */[__webpack_require__.e(9072), __webpack_require__.e(729), __webpack_require__.e(3348), __webpack_require__.e(9362), __webpack_require__.e(20), __webpack_require__.e(9090)]).then(__webpack_require__.bind(__webpack_require__, 53694)).then(function(mod) {
        return mod.HomeLoggedOut;
    });
    return promise;
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53694)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return null;
    }
});
function Home() {
    var appUser = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .a)().appUser;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_seo__WEBPACK_IMPORTED_MODULE_2__/* .SEOHead */ .R, {
                title: "Meki \xb7 Farmacia a domicilio"
            }),
            appUser ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HomeLoggedIn, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HomeLoggedOut, {})
        ]
    });
}


/***/ }),

/***/ 39425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ SEOHead; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var _siteMetaData_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64507);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60031);










var BASE_IMAGES = [
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/Meki.jpg",
        type: "image/jpg",
        width: 1200,
        height: 630
    },
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/1200x630.png",
        type: "image/png",
        width: 1200,
        height: 630
    },
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/256x256.jpg",
        type: "image/jpg",
        width: 256,
        height: 256
    },
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/256x256.png",
        type: "image/png",
        width: 256,
        height: 256
    }, 
];
function SEOHead(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var description = props.description, title = props.title, customImage = props.customImage, canonical = props.canonical;
    var site = _siteMetaData_json__WEBPACK_IMPORTED_MODULE_4__/* .landing */ ._;
    var image = customImage;
    var metaDescription = description ? description : site.description;
    var metaTitle = title || site.title;
    var headData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        title: metaTitle,
        description: metaDescription
    }, canonical ? {
        canonical: canonical
    } : {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, headData), {
                openGraph: {
                    title: metaTitle,
                    description: metaDescription,
                    type: site.type,
                    url: "".concat(_config_environment__WEBPACK_IMPORTED_MODULE_6__/* .BASE_URL */ ._n).concat(router.asPath),
                    images: [
                        image && {
                            url: image.url,
                            width: Number(image.width.replace("px", "")),
                            height: Number(image.height.replace("px", "")),
                            alt: metaTitle
                        }, 
                    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(BASE_IMAGES)).filter(Boolean)
                },
                additionalMetaTags: [
                    {
                        name: "viewport",
                        content: site.scale
                    }
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    charSet: site.charSet
                })
            })
        ]
    });
}


/***/ }),

/***/ 64507:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"_":{"title":"Meki · Farmacia a domicilio","description":"Todo lo que necesitas, hasta los medicamentos difíciles. Precios bajos y convenio con Cenabast. Despacho GRATIS en Santiago por compras sobre $35.000.","author":"@mimeki","type":"website","charSet":"utf-8","scale":"width=device-width, initial-scale=1","image":{"url":"https://meki-public.s3.us-east-2.amazonaws.com/meta/Meki.jpg","type":"image/jpg","width":"1200","height":"630"},"imageCart":{"url":"https://meki-public.s3.us-east-2.amazonaws.com/meta/metadataCarrito.png","type":"image/png","width":"256","height":"256"}}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,9774,2888,179], function() { return __webpack_exec__(54961), __webpack_exec__(8192); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);